import React from 'react'
import { useTranslation } from 'react-i18next'
import { Trans } from 'react-i18next'
import Fade from 'react-reveal/Fade'

const Header = () => {
	// eslint-disable-next-line no-unused-vars
	const { t } = useTranslation()
	return (
		<section className='header py-44 bg-main-dark mb-10'>
			<div className='container mx-auto  md:flex'>
				<div className='w-full md:w-6/12'>
					<div className='px-6'>
						<Fade left cascade>
							<h2 className='text-xl font-extrabold md:text-6xl text-main-secondary'>
								<Trans i18nKey='translation:header:title'>
									FINALLY, <br></br>A PLACE TO SEE WHO’S <br></br>THE BEST
									SPORTS BETTOR
								</Trans>
							</h2>
							<p className='mt-2 text-xl leading-relaxed text-white'>
								{t('translation:header:description')}
							</p>
						</Fade>
					</div>
				</div>
				<div className='w-full md:w-6/12 px-4 mr-auto ml-auto my-16 md:my-0'>
					<img
						alt='header.jpg'
						className='w-full h-full shadow-intro rounded-betish floating'
						src='img/header.jpg'
					/>
				</div>
			</div>
		</section>
	)
}

export default Header
